import axios from "axios";

export async function getAllLinks() {
    const {data} = await axios.get(`/external-link/all`);
    return data.filter(link => link.active === true)
}
